import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { Formik } from "formik";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useNotification } from "../../contexts";
import { createInvite, createInviteWrapper, deleteInvite } from "../../services/invites";
import { TextField } from "../../components/form";
import { INVITE_VALIDATION_SCHEMA as validationSchema } from "../../constants/validation";

export default function ShareDialog({ propertyId = "", unitId = "", invite }) {
  const [isOpen, setIsOpen] = useState(false);
  const { dispatch } = useNotification();

  const handleClickOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const onSubmit = (values) => {
    console.log(values);
    // if (invite?.id) {
    //   deleteInvite({
    //     propertyId,
    //     unitId,
    //     inviteId: invite.id,
    //   }).then((data) => {
    //     createInviteWrapper({ propertyId, unitId, ...values }).then((data) => {
    //       setIsOpen(false);
    //       if (data.message) {
    //         dispatch({
    //           type: "add",
    //           notifications: [{ title: data.message, type: "error" }],
    //         });
    //       } else {
    //         dispatch({
    //           type: "add",
    //           notifications: [
    //             { title: `Invite to ${values.email} was sent with success` },
    //           ],
    //         });
    //       }
    //     });
    //   });
    // } else {
    createInviteWrapper({ propertyId, unitId, ...values }).then((data) => {
      setIsOpen(false);
      if (data.message) {
        dispatch({
          type: "add",
          notifications: [{ title: data.message, type: "error" }],
        });
      } else {
        dispatch({
          type: "add",
          notifications: [
            { title: `Invite to ${values.email} was sent with success` },
          ],
        });
      }
    });
    // }
  };

  return (
    <div>
      <Button onClick={handleClickOpen} size="small">
        Invite
      </Button>
      <Dialog open={isOpen} onClose={handleClose}>
        <DialogTitle>Invite someone</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={{}}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Grid container mt={2}>
                  <p>
                    Provide the first, last name and email of the person you
                    would like to invite to refer this apartment, in most cases
                    this is the current tenant preparing to move out”
                  </p>
                  <Grid item xs={12}>
                    <TextField
                      name="email"
                      type="email"
                      placeholder="Email"
                      variant="standard"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      name="firstName"
                      type="text"
                      placeholder="First Name"
                      variant="standard"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      name="lastName"
                      type="text"
                      placeholder="Last Name"
                      variant="standard"
                    />
                  </Grid>
                  <Grid item xs={12} style={{ textAlign: "right" }}>
                    <Button type="submit">Invite</Button>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
